import { Box, LinearProgress, Tab, Tabs } from '@mui/material'

const StepTabs = ({ steps, activeStep = 0 }: any) => {
  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        backgroundColor: '#f7f7f7',
      }}
    >
      <LinearProgress
        color="secondary"
        variant="determinate"
        value={activeStep * (70 / steps?.length) + 15}
        sx={{
          backgroundColor: '#f7f7f7',
          margin: 0,
          padding: 0,
          marginLeft: '-21.43%',
          marginRight: '-21.43%',
        }}
      />
      <Box
        component="div"
        sx={{
          marginLeft: '-21.43%',
          marginRight: '-21.43%',
          backgroundColor: '#f7f7f7',
          borderBottom: '2px solid #dddddd',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          minHeight: '58px',
        }}
      >
        <Tabs
          aria-label="wizard-step-tabs"
          variant="fullWidth"
          value={0}
          sx={{
            backgroundColor: '#f7f7f7',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            '& .MuiTabs-indicator': {
              backgroundColor: 'transparent',
            },
            '& .MuiTabs-flexContainer': {
              alignItems: 'stretch',
            },
            width: '70%',
            alignSelf: 'center',
            minHeight: '58px',
          }}
        >
          {steps?.map((step: any, index: number) => (
            <Tab
              disabled
              key={`${step?.path}-${index}`}
              label={`${activeStep > index ? '✔' : index + 1 + '.'} ${
                step?.stepLabel
              }`}
              sx={{
                textTransform: 'capitalize',
                fontSize: '15px',
                fontWeight: 'light',
                color: 'var(--jy-navy-900, #00253d)',
                borderLeft: index !== 0 ? '1px solid #dddddd' : null,
                '&:disabled': {
                  color: 'var(--jy-navy-900, #00253d)',
                },
                marginTop: 0,
                minHeight: '58px',
                height: '100%',
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: '15px',
                textAlign: 'left',
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}

export default StepTabs
